export default __webpack_public_path__ + "static/media/all-corners-rounded.033d7501.webp";